import React, { useEffect, useRef } from 'react';
import { Icon, ScrollView } from '../ui';

const Select: React.FC = ({ children }) => <div className="relative db mb1">{children}</div>;

const Selected: React.FC<{ onClick: () => void }> = ({ children, onClick, ...rest }) => (
  <div
    className="flex justify-between items-center ph3 bg-near-white br2"
    style={{ height: 42 }}
    onClick={onClick}
    {...rest}
  >
    <span className="f6 db pr2 flex-auto truncate">{children}</span>
    <div>
      <Icon name="caret-left" size={24} className="rotate-270" color="blue" />
    </div>
  </div>
);

const Options: React.FC<{ onClickOutside: () => void; openDirection?: 'UP' | 'DOWN' }> = ({
  children,
  onClickOutside,
  openDirection = 'DOWN'
}) => {
  const optionsRef = useRef(null);
  const handleClickOutside = (event: any) => {
    const current: any = optionsRef.current || '';
    if (optionsRef.current && !current.contains(event.target)) {
      onClickOutside();
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });
  return (
    <div ref={optionsRef}>
      <ScrollView
        className={`bg-white z-max absolute left-0 ba b--light-gray br2 overflow-hidden shadow-1 w-100 ${
          openDirection === 'DOWN' ? 'top-0' : 'bottom-0'
        }`}
        style={{ maxHeight: 250 }}
      >
        {children}
      </ScrollView>
    </div>
  );
};

const Option: React.FunctionComponent<{
  onClick?: () => void;
  selected?: boolean;
}> = ({ children, selected = false, ...rest }) => (
  <div
    className="flex items-center justify-between bb b--light-gray f6 ph3 bg-white hover-bg-near-white truncate pointer"
    style={{ height: 42 }}
    {...rest}
  >
    <div className="flex-auto truncate navy">{children}</div>

    {selected && (
      <div className="flex-none">
        <Icon name="check" color="navy" />
      </div>
    )}
  </div>
);

export { Select, Selected, Options, Option };
